export default __webpack_public_path__ + "static/media/Cat_R_Rugs_V2.a07fd4b7.jpeg";